// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"Pagination_buttonGroup__K2zol","pageButtons":"Pagination_pageButtons__10Kw5"};